module.exports = __webpack_public_path__ + "static/media/rewards.e87862a1.png";